import React from 'react';
import PropTypes from 'prop-types';
import Thumbnail from './Thumbnail';
import circlePlusIcon from '../../../assets/circle_plus_icon.svg';
import circleCheckIcon from '../../../assets/circle_check_icon.svg';
import styles from '../Playlist.scss';

const SelectablePlaylist = ({ isSelected, playlist, togglePlaylist }) => (
  <Thumbnail
    playlist={playlist}
    action={e => {
      togglePlaylist(e, { value: playlist.id });
    }}
    actionClassName={styles.toggleRecommendation}
    actionIcon={
      isSelected(playlist.id) ? circleCheckIcon : circlePlusIcon
    }
    onClick={e => {
      e.stopPropagation();
      togglePlaylist(e, { value: playlist.id });
    }}
  />
);

SelectablePlaylist.propTypes = {
  isSelected: PropTypes.func.isRequired,
  playlist: PropTypes.object.isRequired,
  togglePlaylist: PropTypes.func.isRequired,
};

export default SelectablePlaylist;



// WEBPACK FOOTER //
// ./webpack/components/Playlist/Recommendation/SelectablePlaylist.js